import React, { useEffect, useState } from "react";
import Select from "react-select";
import { getVendedoresForDropdown, toast } from "../../utils/helpers";
import { postRequest } from "../../utils/request";
import { apiUrl } from "../../utils/apiUrl";

// `seleccion` es { todos, ids, total }: con `todos` el API aplica los mismos
// `filtros` de la lista en lugar de los ids.
const AsignarVendedorForm = ({ toggle, seleccion, filtros = {}, onAsignado }) => {
    const [vendedores, setVendedores] = useState([]);
    const [vendedor, setVendedor] = useState(null);
    const [errors, setErrors] = useState({});
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        getVendedoresForDropdown().then((data) => {
            // El primero es "Todos", que aquí no tiene sentido.
            setVendedores([{ value: "", label: "Sin vendedor" }, ...data.slice(1)]);
        });
    }, []);

    const asignar = async (event) => {
        event.preventDefault();

        if (!vendedor) {
            setErrors({ vendedor_id: ["Este Campo es requerido."] });
            return;
        }

        setErrors({});
        setSaving(true);

        const data = new FormData();
        data.append("vendedor_id", vendedor.value);

        if (seleccion.todos) {
            data.append("todos", 1);
            Object.keys(filtros).forEach((filtro) => data.append(filtro, filtros[filtro] ?? ""));
        } else {
            seleccion.ids.forEach((id) => data.append("contactos[]", id));
        }

        const response = await postRequest(apiUrl("contactos/asignar-vendedor"), data);

        setSaving(false);

        if (response.success) {
            toast(`${response.data.actualizados} clientes actualizados.`);
            onAsignado();
            return;
        }

        if (response.code === 422) {
            setErrors(response.data.message);
            return;
        }

        toast(typeof response.data === "string" ? response.data : "No se pudo asignar el vendedor.", "error");
    };

    return <form method='post' onSubmit={asignar}>
        <div className='popup__header'>Asignar Vendedor</div>
        <div className='popup__body'>
            <div className='row'>
                <div className='col-md-12'>
                    <p>
                        {seleccion.todos
                            ? `Se asignará a los ${seleccion.total} contactos que coinciden con el filtro.`
                            : `Se asignará a ${seleccion.ids.length} contacto(s) seleccionado(s).`}
                        {" "}Los proveedores se omiten.
                    </p>
                    <div className='form-group'>
                        <label className="label form-control-label">
                            Vendedor:
                        </label>
                        <Select
                            id="vendedor_id"
                            options={vendedores}
                            value={vendedor}
                            onChange={setVendedor}
                            placeholder="Seleccionar..."
                            classNamePrefix="select-menu-z-999"
                            styles={{
                                control: (styles) => ({
                                    ...styles,
                                    height: "38px",
                                }),
                            }}
                        />
                        {errors.vendedor_id && (
                            <small className="help-blockParams form-Text">
                                {errors.vendedor_id[0]}
                            </small>
                        )}
                        {errors.contactos && (
                            <small className="help-blockParams form-Text">
                                {errors.contactos[0]}
                            </small>
                        )}

                        <div style={{height: '250px', width: '100%'}}></div>
                    </div>
                </div>
            </div>
        </div>

        <div className='popup__footer'>
            <div className="row">
                <button type="button" className="btn btn-plain mr-auto" onClick={toggle}>
                    Cancelar
                </button>
                <button type='submit' className='btn btn-primary ml-auto' disabled={saving}>
                    {saving ? "Guardando..." : "Asignar"}
                </button>
            </div>
        </div>
    </form>;
};

export default AsignarVendedorForm;
